import React, { type FC } from 'react';

import styles from './ecg-details.module.sass';
import { ECGWaveFormResponseDto, AccountPublicResponseDto } from 'types/types';
import { getLocaleDate } from 'utils';
import { EVERBEAT_WEBPAGE, TIME_SCALE, MV_PER_ROW } from 'utils/constants';

type EcgDetailsProperties = {
  accountData: AccountPublicResponseDto;
  ecgWaveForm: ECGWaveFormResponseDto;
};

const EcgDetails: FC<EcgDetailsProperties> = ({ accountData, ecgWaveForm }) => {
  return (
    <>
      <div className={styles.info_container}>
        <a className={styles.link} rel='noreferrer' target='_blank' href={EVERBEAT_WEBPAGE}>
          Recorded: {getLocaleDate(ecgWaveForm.submittedTimestamp)}
        </a>
      </div>
      <ul>
        <li>
          Name: {accountData?.firstName} {accountData?.lastName}
        </li>
        <li>{ecgWaveForm.ecgLead}</li>
        <li>Voltage Scale: {MV_PER_ROW} mV/division </li>
        <li>Time Scale: {TIME_SCALE}</li>
        <li>Heart rate: {ecgWaveForm?.heartRate} bpm</li>
        <li>Assessment: {ecgWaveForm?.assessment}</li>
      </ul>
    </>
  );
};

export { EcgDetails };
